import React, { useState } from 'react';

import Button from '@mui/material/Button';
import DownloadIcon from '@mui/icons-material/Download';
import { DropzoneDialog } from 'mui-file-dropzone';
import { ManageChartTemplateActionType } from '../../ManageChartTemplateContext/ManageChartTemplateReducer';
import { convertFileToBase64 } from 'ui/TextEditor/helpers';
import { styled } from '@mui/material';
import { useManageChartTemplateContext } from '../../ManageChartTemplateContext/ManageChartTemplateContext';
import { useTranslation } from 'react-i18next';

const StyPreviewZoneContainer = styled('div')(({ theme }) => ({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
}));

const StyPreviewImage = styled('img')({
    objectFit: 'contain',
    height: 230,
});

const PreviewDropzone = () => {
    const { t } = useTranslation();
    const [openDropzone, setOpenDropzone] = useState(false);
    const {
        state: { preview },
        dispatch,
    } = useManageChartTemplateContext();

    return (
        <StyPreviewZoneContainer>
            <Button
                color="primary"
                onClick={() => setOpenDropzone(true)}
                startIcon={<DownloadIcon />}
                variant="contained"
            >
                {t(
                    'support.chartsTemplates.createOrEditModal.previewZone.open',
                )}
            </Button>
            {preview.length !== 0 && (
                <StyPreviewImage alt="Indicator preview image" src={preview} />
            )}
            <DropzoneDialog
                open={openDropzone}
                acceptedFiles={['image/*']}
                fileObjects={[]}
                showPreviews={false}
                dialogTitle=""
                dropzoneText={t(
                    'support.clientConfiguration.customization.addImage',
                )}
                previewGridProps={{
                    container: {
                        display: 'flex',
                        justifyContent: 'center',
                    },
                }}
                cancelButtonText={t('common.cancel')}
                submitButtonText={t('common.confirm')}
                showPreviewsInDropzone
                onClose={() => setOpenDropzone(false)}
                onSave={async (files: File[]) => {
                    return convertFileToBase64(files[0]).then(
                        (newPreview: string) => {
                            dispatch({
                                type: ManageChartTemplateActionType.CustomizeChartTemplate,
                                payload: { preview: newPreview },
                            });
                            setOpenDropzone(false);
                            return null;
                        },
                    );
                }}
            />
        </StyPreviewZoneContainer>
    );
};

export default PreviewDropzone;
